<div class="lcs-error-container">
  <div class="lcs-page-403">
    <div class="d-flex flex-column flex-lg-row align-items-center justify-content-center">
      <div class="lcs-error-name">403</div>
      <span class="delimiter"></span>
      <div class="lcs-error-message">
        <h1 class="title">{{'t.accessDeniedTitle' | translate}}</h1>
        <h1 class="message">{{'t.accessDeniedMsg' | translate}}</h1>
      </div>
    </div>
  </div>
</div>
